<template>
  <div class="mx-auto w-full max-w-7xl px-4 sm:px-6">
    <slot />
  </div>
</template>
